import Vue from 'vue'
import Vuex from 'vuex'
import toShow from './modules/toShow'
import userLogin from './modules/user_login'
import prompt from './modules/prompt'
import setRead from './modules/setRead'
import app from './modules/app'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    app,
    toShow,
    userLogin,
    prompt,
    setRead
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js